angular
  .module('jv.search.config.service', [])
  .service('jvSearchConfigService', [
    '$http',
    '$q',
    function($http, $q) {
      var baseUrl = window.jvUrls.jhire + '/action/application/search/config';
      this.get = function() {
        var restOption = {
          method: 'GET',
          url: baseUrl
        };
        var defer = $q.defer();

        $http(restOption).then(
          function(response) {
            defer.resolve(response.data);
          },
          function(err) {
            defer.reject(err);
          }
        );
        return defer.promise;
      };
    }
  ]);